module.exports = __webpack_public_path__ + "static/media/bg_kc_8.88fb9ce3.jpg";